module.exports = "<div class=\"page-footer\">\r\n    <div class=\"row\">\r\n        <div class=\"col-xs-12 col-sm-6\">\r\n            <span class=\"txt-color-white\">Senac DN :: 2018</span>\r\n        </div>\r\n\r\n        <div class=\"col-xs-12 col-sm-6 text-right\">\r\n            <span class=\"txt-color-white\">{{modulo}}</span>\r\n        </div>\r\n\r\n\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/footer/footer.component.html
// module id = ./src/app/shared/layout/footer/footer.component.html
// module chunks = main